import { hasPoorContrastWithWhite, isValidHexColor } from "../../theme/companyTheme";

const WARNING_COPY =
  "This color may be hard to read as text on white backgrounds. The portal will keep your selected brand color for badges and accents, but automatically use a darker accessible version for text where needed.";

export default function ThemeContrastWarning({ color }) {
  if (!isValidHexColor(color) || !hasPoorContrastWithWhite(color)) {
    return null;
  }

  return (
    <div
      className="d-flex align-items-start gap-2 mt-2 p-2 rounded"
      style={{
        background: "#fcefe2",
        border: "1px solid #ff9500",
        fontSize: "13px",
        color: "#45464e",
      }}
      role="status"
    >
      <span aria-hidden="true">⚠️</span>
      <span>{WARNING_COPY}</span>
    </div>
  );
}
